import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-error" }
const _hoisted_8 = { class: "col-lg-4 col-sm-6" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = { class: "input-error" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4 col-sm-6" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = {
  key: 0,
  class: "input-error"
}
const _hoisted_15 = { class: "col-lg-4 col-sm-6" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = {
  key: 0,
  class: "input-error"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-4 col-sm-6" }
const _hoisted_20 = { class: "form-group mb-4" }
const _hoisted_21 = {
  key: 0,
  class: "input-error"
}
const _hoisted_22 = { class: "col-lg-4 col-sm-6" }
const _hoisted_23 = { class: "form-group mb-4" }
const _hoisted_24 = { class: "form-check form-switch" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-4 col-sm-6" }
const _hoisted_27 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "input-error" }
const _hoisted_30 = { class: "col-lg-4 col-sm-6" }
const _hoisted_31 = { class: "form-group mb-4" }
const _hoisted_32 = { class: "input-error" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-lg-4 col-sm-6" }
const _hoisted_35 = { class: "form-group mb-4" }
const _hoisted_36 = { class: "input-error" }
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = {
  key: 1,
  class: "row"
}
const _hoisted_39 = { class: "col-lg-4 col-sm-6" }
const _hoisted_40 = { class: "form-group mb-4" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "col-lg-4 col-sm-6" }
const _hoisted_43 = { class: "form-group mb-4" }
const _hoisted_44 = {
  key: 2,
  class: "row"
}
const _hoisted_45 = { class: "col-lg-4 col-sm-6" }
const _hoisted_46 = { class: "form-group mb-4" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "col-lg-4 col-sm-6" }
const _hoisted_49 = { class: "form-group mb-4" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "col-lg-6" }
const _hoisted_52 = { class: "form-group mb-4 p-4 bg-body d-sm-flex justify-content-between align-items-center rounded-3" }
const _hoisted_53 = { class: "d-sm-flex align-items-center mb-3 mb-sm-0 me-lg-3 position-relative" }
const _hoisted_54 = { class: "position-relative d-inline-block" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "d-flex ms-sm-3 ms-md-0" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-lg-12" }
const _hoisted_59 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_63 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[28] || (_cache[28] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.itemsCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "label text-secondary" }, "Empresa/Institución", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.player.companyId) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('companyId')))
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompany, (company, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: company.id,
                        key: i
                      }, _toDisplayString(company.name), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.player.companyId]
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors.companyId), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "label text-secondary" }, "Username (correo)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el username",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.player.email) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('email')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.email,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.errors.email), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "label text-secondary" }, "Nombres", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del usuario",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.player.firstName) = $event)),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('firstName')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.firstName,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.firstName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errors.firstName), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "label text-secondary" }, "Apellidos", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el apellido del usuario",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.player.lastName) = $event)),
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('lastName')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.lastName,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.lastName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errors.lastName), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "label text-secondary" }, "Contraseña (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar una contraseña",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.player.password) = $event)),
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('password')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.password,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.password)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errors.password), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "label text-secondary" }, "¿Cambiar contraseña al 1er login?", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  role: "switch",
                  id: "flexSwitchCheckDefault",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.player.forcePasswordChange) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.player.forcePasswordChange]
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexSwitchCheckDefault"
                }, null, -1 /* HOISTED */))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            (_ctx.itemsDocumentType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo documento (opcional)", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.player.documentTypeId) = $event)),
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearError('documentTypeId')))
                  }, [
                    _cache[37] || (_cache[37] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsDocumentType, (documentType, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: documentType.id,
                        key: i
                      }, _toDisplayString(documentType.name), 9 /* TEXT, PROPS */, _hoisted_28))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.player.documentTypeId]
                  ]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.errors.documentTypeId), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label text-secondary" }, "Documento de identidad (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el username",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.player.documentNumber) = $event)),
                onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearError('documentNumber')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.documentNumber,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.errors.documentNumber), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label text-secondary" }, "Teléfono/Celular (opcional)", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el Teléfono/Celular",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.player.phoneNumber) = $event)),
                onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearError('phoneNumber')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.player.phoneNumber,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.errors.phoneNumber), 1 /* TEXT */)
            ])
          ]),
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "col-lg-4 col-sm-6" }, [
            _createElementVNode("div", { class: "form-group mb-4" })
          ], -1 /* HOISTED */))
        ]),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _cache[42] || (_cache[42] = [
              _createElementVNode("h3", { class: "mb-0" }, "Datos adicionales", -1 /* HOISTED */)
            ])))
          : _createCommentVNode("v-if", true),
        _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label text-secondary" }, "Alias", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control h-45",
                    placeholder: "Ingresar el Alias",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.player.alias) = $event)),
                    onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearError('alias'))),
                    disabled: !_ctx.canEditAlias
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_41), [
                    [
                      _vModelText,
                      _ctx.player.alias,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createCommentVNode("  <div v-if=\"errors.alias\" class=\"input-error\">\r\n                {{ errors.alias }}\r\n              </div> ")
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label text-secondary" }, "Fecha de Nacimiento", -1 /* HOISTED */)),
                  _createVNode(_component_VueDatePicker, {
                    modelValue: _ctx.player.birthdate,
                    "onUpdate:modelValue": [
                      _cache[19] || (_cache[19] = ($event: any) => ((_ctx.player.birthdate) = $event)),
                      _cache[20] || (_cache[20] = ($event: any) => (_ctx.clearError('birthdate')))
                    ],
                    placeholder: "Selecciona una fecha",
                    format: "dd/MM/yyyy",
                    "format-locale": _ctx.es,
                    "enable-time-picker": false,
                    teleport: "",
                    disabled: !_ctx.canEditBirthdate
                  }, null, 8 /* PROPS */, ["modelValue", "format-locale", "disabled"]),
                  _createCommentVNode("  <div class=\"input-error\">{{ errors.birthdate }}</div>\r\n            </div> ")
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "label text-secondary" }, "Motivos de participación", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "4",
                    style: {"resize":"none"},
                    class: "form-control text-dark no-resize",
                    placeholder: "Ingresar Motivo de participación",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.player.participationReasons) = $event)),
                    onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.clearError('participationReasons'))),
                    disabled: !_ctx.canEditParticipationReasons
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_47), [
                    [
                      _vModelText,
                      _ctx.player.participationReasons,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createCommentVNode("  <div v-if=\"errors.participationReasons\" class=\"input-error\">\r\n                {{ errors.participationReasons }}\r\n              </div> ")
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[46] || (_cache[46] = _createElementVNode("label", { class: "label text-secondary" }, "Otros", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control h-45",
                    placeholder: "Otros",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.player.otherInfo) = $event)),
                    onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.clearError('alias'))),
                    disabled: !_ctx.canEditAlias
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_50), [
                    [
                      _vModelText,
                      _ctx.player.otherInfo,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "me-md-5 pe-xxl-5 mb-3 mb-sm-0" }, [
                _createElementVNode("h4", { class: "body-font fs-15 fw-semibold text-body" }, "Tu foto")
              ], -1 /* HOISTED */)),
              _createCommentVNode(" Image Container "),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("img", {
                  class: "rounded-4 wh-75 ms-3 ms-lg-0 rounded-circle",
                  src: _ctx.profileUrl,
                  alt: "user",
                  style: {"width":"125px","height":"125px","object-fit":"cover"}
                }, null, 8 /* PROPS */, _hoisted_55),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-light position-absolute bottom-0 end-0 rounded-circle",
                  style: {"transform":"translate(25%, 25%)"},
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                }, _cache[47] || (_cache[47] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, "add_a_photo", -1 /* HOISTED */)
                ])),
                _createCommentVNode(" Hidden file input "),
                _createElementVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  accept: "image/*",
                  onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                  class: "d-none"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                type: "button",
                class: "btn bg-danger bg-opacity-10 text-danger fw-semibold",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.resetProfilePhoto && _ctx.resetProfilePhoto(...args)))
              }, " Eliminar ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_RouterLink, { to: "/players" }, {
                default: _withCtx(() => _cache[49] || (_cache[49] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.player.id == 0 ? "Crear Jugador" : "Actualizar Jugador"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_60)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}